import * as React from "react";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import PropTypes from "prop-types";
import { useStyles } from "./styles";
import { useTheme } from "@emotion/react";

export default function MultiselectAutocomplete({
  lists = [],
  setSelectedValues,
  placeholder = "",
  selectedItems = [],
}) {
  const theme = useTheme();
  const classes = useStyles({ theme });

  return (
    <Autocomplete
      multiple
      disableCloseOnSelect
      id="autocomplete"
      options={lists}
      getOptionLabel={(option) => option.title}
      filterSelectedOptions
      value={selectedItems}
      onChange={(_, newValue) => {
        setSelectedValues(newValue.map((item) => item));
      }}
      slotProps={{
        paper: {
          sx: {
            backgroundColor: theme.palette.themeColor,
            color: theme.palette.text.primary,
          },
        },
        listbox: {
          sx: {
            "& .MuiAutocomplete-option": {
              "&:hover": {
                backgroundColor:
                  theme.palette.mode === "light"
                    ? "#d1d1d1ff"
                    : "rgba(255, 255, 255, 0.16)",
              },
            },
            maxHeight: 250,
            overflowY: "auto",
          },
        },
      }}
      renderInput={(params) => (
        <TextField
          slotProps={{ inputLabel: { shrink: false } }}
          className={classes.inputText}
          {...params}
          placeholder={
            selectedItems.length === 0 ? placeholder || "Select Options" : ""
          }
          sx={{
            "& .MuiOutlinedInput-root": {
              "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                borderColor: "rgba(0,0,0,0.23)",
              },
              "&.Mui-focused": {
                boxShadow: "none",
              },
            },
            "& .MuiInputBase-input:focus": {
              outline: "none",
            },
          }}
        />
      )}
    />
  );
}

MultiselectAutocomplete.propTypes = {
  lists: PropTypes.array,
  setSelectedValues: PropTypes.func,
  placeholder: PropTypes.string,
  selectedItems: PropTypes.array,
};
